export default "__VITE_ASSET__c16cb113__"